// Paths
import {
  TEAM,
  SINGLE_CREATE,
  TRANSACTIONS,
  IN_PROGRESS,
  SINGLE_UPDATE,
  IN_STATUS_CHECK,
  BULK_CREATE,
  BULK_UPDATE_STATUS,
  BULK_UPDATE,
  SD_LANDING_PAGE,
  SD_SCHEDULING,
  SD_SCHEDULED_DATA,
  SD_DETAILS,
  GROUP_PAYDATE,
} from "global/paths";

// Team
import TeamStack from "pages/TeamStack";
import Team from "pages/Team";
import SingleCreate from "pages/SingleCreate";
import SingleUpdate from "pages/SingleUpdate";
import InProgress from "pages/InProgress";
import Create from "pages/BulkCreateAndUpdate/create";
import BulkUpdate from "pages/BulkCreateAndUpdate/BulkUpdate";
import BulkUpdateStatus from "pages/BulkCreateAndUpdate/BulkUpdateStatus";
import InStatusCheck from "pages/InStatusCheck";

// Transactions
import Transactions from "pages/Transactions";

// Salary Disbursement
import SDStack from "pages/SDStack";
import SalaryDisbursement from "pages/SalaryDisbursement";
import SDScheduling from "pages/SDScheduling";
import SDScheduledData from "pages/SDScheduledData";
import SDDetails from "pages/SDDetails";

// Icons
import { BsFillPeopleFill } from "react-icons/bs";
import { TbChartHistogram } from "react-icons/tb";
import { CiMoneyBill } from "react-icons/ci";
import { AiOutlineApartment } from "react-icons/ai";
import GroupPayDate from "pages/GroupPayDate";

const routeData = [
  {
    id: 1,
    name: "sideBar.manageTeam",
    element: <TeamStack />,
    path: TEAM,
    icon: <BsFillPeopleFill size="17px" style={{ marginBottom: "-3px" }} />,
    amplitudeEvent: "team_menu_clicked",
    children: [
      {
        id: 1,
        element: <Team />,
        path: TEAM,
      },
      {
        id: 2,
        element: <SingleCreate />,
        path: SINGLE_CREATE,
      },
      {
        id: 3,
        element: <InProgress />,
        path: IN_PROGRESS,
      },
      {
        id: 4,
        element: <SingleUpdate />,
        path: SINGLE_UPDATE,
      },
      {
        id: 5,
        element: <InStatusCheck />,
        path: IN_STATUS_CHECK,
      },
      {
        id: 6,
        element: <Create />,
        path: BULK_CREATE,
      },
      {
        id: 7,
        element: <BulkUpdate />,
        path: BULK_UPDATE,
      },
      {
        id: 8,
        element: <BulkUpdateStatus />,
        path: BULK_UPDATE_STATUS,
      },
    ],
  },
  {
    id: 2,
    name: "sideBar.groupAndPayDate",
    element: <GroupPayDate />,
    path: GROUP_PAYDATE,
    icon: <AiOutlineApartment size="17px" style={{ marginBottom: "-3px" }} />,
    amplitudeEvent: "group&paydate_menu_clicked",
  },
  {
    id: 3,
    name: "sideBar.transactionHistory",
    element: <Transactions />,
    path: TRANSACTIONS,
    icon: <TbChartHistogram size="17px" style={{ marginBottom: "-3px" }} />,
    amplitudeEvent: "transactions_menu_clicked",
  },
  {
    id: 4,
    name: "sideBar.salaryDisbursement",
    element: <SDStack />,
    isSDA: true,
    path: SD_LANDING_PAGE,
    icon: <CiMoneyBill size="17px" style={{ marginBottom: "-3px" }} />,
    amplitudeEvent: "salary_disbursement_menu_clicked",
    children: [
      {
        id: 1,
        element: <SalaryDisbursement />,
        path: SD_LANDING_PAGE,
      },
      {
        id: 2,
        element: <SDScheduling />,
        path: SD_SCHEDULING,
      },
      {
        id: 3,
        element: <SDScheduledData />,
        path: SD_SCHEDULED_DATA,
      },
      {
        id: 4,
        element: <SDDetails />,
        path: SD_DETAILS,
      },
    ],
  },
];

export default routeData;
